export const SET_CATEGORIES = 'SET_VIDEO_HISTORY_LIMIT';

export const SET_FOLLOWS = 'SET_VIDEO_HISTORY_OFFSET';
